import React, { useEffect, useState } from "react";
import {
  CModal,
  CModalBody,
} from "@coreui/react";



// import Select from "react-select";

import Swal from 'sweetalert2';

import { useDispatch, } from "react-redux";
import crossButton from "../../../components/assets/image/crossButton.svg"; 
import "../../../components/common/styles/changePassword.css";
import "../../../components/common/styles/createAdmin.css";
import { hideAddSettingsModal, showAddSettingsModal } from "../redux/settingsModalDispatcher";

import { addSettingsRequest } from "../redux/settingsDispatcher";
import { imageBaseUrls } from "../../../constant/ApiUrls";
import placeholderImage from "../../../components/assets/image/placeholder.png"; 
import { useRef } from "react";
import Cropper from "react-cropper";
// import Cropper from '';
// import '../../../../node_modules/cropperjs/dist/cropper.css';
import '../../../../node_modules/cropperjs/dist/cropper.css';



const AddSettings = ({
   buttonLabel = "Add Settings", 
   editMode = false,
   settingsData = {},
   imagesField=[],
   linkFields=[],

   }) => {

          console.log("SGHSGHSGHSGH::::::",(settingsData));

          
  
const [tempBlob, setTempBlob] = useState(null);


  const dispatch = useDispatch();

  const [isModalVisible, setIsModalVisible] = useState(false); // Local State
  
  const [settingsName, setSettingsName] = useState("");
  const [settingsValue, setSettingsValue] = useState(null);
  const [uploadImage, setUploadImage] = useState(null);


  const [cropperVisible, setCropperVisible] = useState(false);
const [cropperSrc, setCropperSrc] = useState(null);

const cropperRef = useRef(null);


useEffect(() => {
  if (editMode && settingsData) {
    setSettingsName(settingsData.col || "");
    if(imagesField.includes(settingsData.col) ) {
      setSettingsValue(imageBaseUrls(settingsData.value));
    } else {
      setSettingsValue(settingsData.value);
    }
  } 
}, [editMode, settingsData, imagesField]);



  const resetForm = () => {
    setSettingsName("");
    setUploadImage(null);
    setCropperSrc(null);
  };

  const handleCrop = () => {

    const cropper = cropperRef.current?.cropper;
    console.log("handle crop", cropper);
    if (cropper) {
    const canvas = cropper.getCroppedCanvas();

          const width = canvas.width;
    const height = canvas.height;
    console.log("HEIGHT:::::::",height,width);

    if(height<420 ||width<1260)
    {
    setCropperVisible(false);

      canvas.toBlob((blob) => {
        setTempBlob(blob);
       handleIssueImageSize(blob);
      }, "image/png");

      
    }
    else
    {
 cropper.getCroppedCanvas().toBlob((blob) => {
        const croppedUrl = URL.createObjectURL(blob);
        setSettingsValue(croppedUrl);
        setUploadImage(new File([blob], "cropped-image.png", { type: "image/png" }));
        setCropperVisible(false);
      }, "image/png");
    }

     
    }
  };



  
  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const validTypes = ["image/jpeg", "image/png", "image/jpg"];
      if (validTypes.includes(file.type)) {
        const imageUrl = URL.createObjectURL(file);
        setCropperSrc(imageUrl);
        setCropperVisible(true);
        setUploadImage(file); // Keep the original file if needed later
      } else {
        alert("Please select a valid image file (JPEG, PNG, JPG)");
      }
    }
  };


  const handlePixelWarningChoice = (proceed,blb) => {
        console.log("URLLLLLLLLLLLLLL::::::::",proceed,tempBlob,blb);

  if (proceed && blb) {
    const croppedUrl = URL.createObjectURL(blb);
    console.log("URLLLLLLLLLLLLLL::::::::",croppedUrl);
    setSettingsValue(croppedUrl);
    setUploadImage(new File([blb], "cropped-image.png", { type: "image/png" }));
  } else {
    resetForm();
  }

  setTempBlob(null);
};




 const handleIssueImageSize = (blb) => {
    Swal.fire({
      title: ``,
      html:
        "" +
        "The cropped image size is not 1260×420. It may appear pixelated. Continue?",
      showCancelButton: true,
      cancelButtonText: "No",
      confirmButtonText: `Yes, Continue`,
      showCloseButton: true,
      cancelButtonColor: "gray",
      confirmButtonColor: "#4f83df",
      reverseButtons: true
    }).then(async (result) => {
      console.log("RESULT::::::::::",result,result.isConfirmed)
      if (result.isConfirmed) {
         handlePixelWarningChoice(true,blb)
      }
      else
      {
        handlePixelWarningChoice(false,blb)
      }
    });
  };


  // // Handle Image Upload
  // const handleImageChange = (event) => {
  //   const file = event.target.files[0];
  //   if (file) {
  //     const validTypes = ["image/jpeg", "image/png", "image/jpg"];
  //     if (validTypes.includes(file.type)) {
  //       const imageUrl = URL.createObjectURL(file);

  //       setSettingsValue(imageUrl);
        
  //       setUploadImage(file);

  //     } else {
  //       alert("Please select a valid image file (JPEG, PNG, JPG)");
  //     }
  //   }
  // };



  // Handle Add Setting Submission
  const handleAddSettings = () => {


    console.log("ADD-Settings:::::::::",settingsName);
    console.log("ADD-Settings:::::::::",settingsValue);

    if (settingsName.trim() === "") {
      alert("Settings name is required");
      return;
    }

    if( settingsValue.trim()==="")
    {
      alert("Settings value is required");
      return;
  } else if(linkFields.includes(settingsData.col)&&(isValidURL(settingsValue)===false ))
  {
    alert("Please put correct link");
    return;


  }
  function isValidURL(str) {
    try {
      console.log("ISVALID URL::::",str);
      new URL(str);
      console.log("STRRR")
      return true;
    } catch (e) {
      return false;
    }
  }
 

    var data = {
      "col":settingsName,
      'value':settingsValue.replace(imageBaseUrls(null), ''),
      };
     
      if (uploadImage!== null && imagesField.includes(settingsData.col)){
        data.image = uploadImage;
      }


      if(editMode){
        data.id = settingsData.id;
      }




    dispatch(addSettingsRequest(data));
    resetForm();
    setIsModalVisible(false);
    dispatch(hideAddSettingsModal());
  };

  return (
    <div>
      {/* Button to Open Modal */}
         <button
                onClick={() => {
                  if (!editMode) {
                    resetForm(); // Reset the form if adding
                  }
                  setIsModalVisible(true)
                  dispatch(showAddSettingsModal())

                }}
                style={{
                  backgroundColor: editMode===true?"#1b87f4":"rgb(0 0 0)",
                  color: "white",
                  border: "none",
                  cursor: "pointer",
                  borderRadius: "4px",
                  fontSize:editMode===true?"10px":"14px",
                  minWidth:"60px",
                  // width: "100%",
                  height: editMode===true?"24px":"30px",  // Increased height
                  padding: editMode===true?"2px 5px":"4px 10px", // Added padding
                  display: "flex",
                  alignItems: "center",
                  // alignSelf:"end",
                  justifyContent: "center",
                }}
              >{buttonLabel}</button>
    
      <CModal
        alignment="center"
        visible={isModalVisible}
        onClose={() =>setIsModalVisible(false)}
        className="attributemodal"

      >
        <CModalBody className="main-container createAdmin" >
          {/* Close Button */}
          <div className="d-flex justify-content-between align-items-center mb-4 mt-2">
  <h5 
    className="h5 fw-bold ml-0"
    style={{ color: "#007bff", textAlign:"left", flex: 1, paddingLeft:"20px" }}
  >
    <b>{editMode === true ? (imagesField.includes(settingsData.col) ? "Edit Settings" : "Edit Settings") : ("Add New Settings")}</b>
  </h5>

  <img
    onClick={() => setIsModalVisible(false)}
    src={crossButton}
    alt="close"
    className="cross-button"
    style={{ cursor: "pointer", marginLeft: "10px", marginTop:"0px"}}
  />
</div>

            <form onSubmit={(e) => e.preventDefault()} className="login-form">
            
            

              {/* Settings Name Input */}
              {editMode===false?
              
              <div className="mb-3 input-login-box">
                <input
                  value={settingsName}
                  onChange={(e) => setSettingsName(e.target.value)}
                  name="settingName"
                  type="text"
                  className="form-control login-input"
                  placeholder="Enter setting name"
                />
              </div>
              
              :<div></div>}


                {/* Settings Value Input */}
               {
                imagesField.includes(settingsData.col)?
                
              
              <div className="mb-3 input-login-box">
              <div
                className="image-upload-container text-center"
                onClick={() => document.getElementById("settingsImageUpload").click()}
              >
                <input
                  type="file"
                  accept="image/*"
                  id="settingsImageUpload"
                  style={{ display: "none" }}
                  onChange={handleImageChange}
                />
                <img
                  src={settingsValue || placeholderImage}
                  alt="Settings Preview"
                  className="settings-preview-image"
                />
                <div className="image-overlay">
                  Change Image
                </div>
              </div>
            </div>
                :
                
                
                
                <div className="mb-3 input-login-box">
                <input
                  value={settingsValue}
                  onChange={(e) => setSettingsValue(e.target.value)}
                  name="settingValue"
                  type="text"
                  className="form-control login-input"
                  placeholder="Enter setting value"
                />
              </div>
               }















              {/* Submit Button */}
              <button
                className="w-100 btn btn-md btn-warning fw-bold text-light button-color"
                type="button"
                onClick={handleAddSettings}
              >
                  {editMode ? "Update" : "Submit"}
              </button>
            </form>
        </CModalBody>
      </CModal>
      {/* Cropper Modal */}
      {cropperVisible && (
        <CModal alignment="center" visible={cropperVisible} onClose={() => setCropperVisible(false)}>
          <CModalBody className="text-center">
            <Cropper
             ref={cropperRef} // <-- Correct way to access .cropper
             src={cropperSrc}
              
              style={{ height: 400, width: "100%" }}
              initialAspectRatio={16 / 9}
              guides={false}
              viewMode={1}
              responsive={true}
              autoCropArea={1}
              checkOrientation={false}
              // onInitialized={(instance) => {
              //   console.log("--------------------", instance);
              //   cropperRef.current = instance;
              // }}
            />
            <button className="btn btn-primary mt-3" onClick={handleCrop}> 
              Crop & Save
            </button>
          </CModalBody>
        </CModal>
      )}

  


    </div>
  );
};

export default AddSettings;
